import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminDashboard from '../components/dashboard/adminDashboard';
import * as BillAction from '../actions/billAction';
function mapStateToProps(state) {
  return {
    adminBalance: state.Bill.currentBalance,
    verAccDetails: state.Bill.verAccDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...BillAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard);
